import {
  Breadcrumbs,
  Link,
  Divider as MuiDivider,
  Typography,
  styled,
  Grid,
} from "@material-ui/core";
import { useState } from "react";
import { Helmet } from "react-helmet-async";
import { NavLink } from "react-router-dom";
import PivotGrid from "../../components/PivotGridApplicationsSummary";
import { spacing } from "@material-ui/system";
import useLocale from "../../hooks/useLocale";
import { useQuery } from "react-query";
import YearSelect from "./YearSelect";
import MonthSelect from "./MonthSelect";
import dayjs from "dayjs";
import { fetchApplicationsSummary } from "../../services/applicationsSummary";
import { fetchPortAuthorities } from "../../services/portAuthoritiesService";

const Divider = styled(MuiDivider)(spacing);

const UserStatistics = () => {
  const [month, setMonth] = useState(dayjs().month() + 1);
  const [year, setYear] = useState(dayjs().year());
  const { t } = useLocale();

  const { data: applicationsSummaryData, isLoading } = useQuery(
    ["applicationSummaryData", month, year],
    fetchApplicationsSummary
  );

  const { data: PortAuthorities } = useQuery(
    "portAuthorities",
    fetchPortAuthorities
  );

  // Get the port name based on port_authority_id
  const applicationsSummaryDataWithPortnames = applicationsSummaryData?.map(
    (data) => {
      const portAuthority = PortAuthorities?.find(
        (port) => port.id === data.port_authority_id
      );
      if (portAuthority) {
        return { ...data, portName: portAuthority.dscr };
      } else {
        return { ...data };
      }
    }
  );

  return (
    <>
      <Helmet title={t("Applications Summary")} />
      <Typography variant="h3" gutterBottom display="inline">
        {t("Applications Summary")}
      </Typography>

      <Breadcrumbs aria-label="Breadcrumb" mt={2}>
        <Link component={NavLink} exact to="/">
          {t("Dashboard")}
        </Link>

        <Typography>{t("Applications Summary")}</Typography>
      </Breadcrumbs>
      <Divider my={6} />

      <Grid container spacing={5} style={{ marginBottom: 25 }}>
        <Grid item xs={3}>
          <YearSelect
            value={year}
            handleChange={(e) => setYear(e.target.value)}
          />
        </Grid>
        <Grid item xs={3}>
          <MonthSelect
            value={month}
            handleChange={(e) => setMonth(e.target.value)}
          />
        </Grid>
      </Grid>
      <PivotGrid
        data={applicationsSummaryDataWithPortnames}
        isLoading={isLoading}
      />
    </>
  );
};

export default UserStatistics;
